export function compareWidget() {
    return {
        products: [],
        slots: ['', '', ''],

        standardRows: [],

        init() {
            const el = document.getElementById('compare-products-data')
            if (el) {
                try { this.products = JSON.parse(el.textContent) }
                catch (e) { console.error('[compareWidget] Failed to parse products JSON', e) }
            }
            const sr = document.getElementById('compare-standard-rows')
            if (sr) {
                try { this.standardRows = JSON.parse(sr.textContent) }
                catch (e) { console.error('[compareWidget] Failed to parse standard-rows JSON', e) }
            }
        },

        get hasSelection() {
            return this.slots.some(Boolean)
        },

        getProduct(id) {
            return this.products.find(p => p.id === id) || {}
        },

        setSlot(i, val) {
            // Select values arrive as strings; product ids in the embedded JSON
            // are numbers — cast so getProduct()'s strict-equals lookup matches.
            this.slots[i] = val === '' ? '' : Number(val)
            this.slots = [...this.slots]
        },

        get allRowLabels() {
            // Use standard rows (WC attribute labels), append any product-specific extras.
            const labels = [...this.standardRows]
            this.slots.filter(Boolean).forEach(id => {
                const p = this.getProduct(id)
                ;(p.rows || []).forEach(r => {
                    if (r.label && !labels.includes(r.label)) labels.push(r.label)
                })
            })
            // Sort alphabetically.
            return labels
        },

        getRowValue(id, label) {
            const p = this.getProduct(id)
            const row = (p.rows || []).find(r => r.label === label)
            return row ? row.value : ''
        },
    }
}
